var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"pt-2 pb-2",class:_vm.classList},[_vm._t("default",function(){return [_vm._v("Footer")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }